import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { useGallery } from "./Dishes";
import { useSiteContent } from "./siteContent";

export default function GalleryPage() {
  const photos = useGallery();
  const site = useSiteContent();

  return (
    <div
      data-testid="gallery-page"
      className="min-h-screen bg-[#F4F1EB] text-[#102C1F]"
    >
      <header className="sticky top-0 z-50 bg-[#102C1F] text-[#F4F1EB]">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 md:px-10">
          <span className="font-display text-xl italic md:text-2xl">
            {site.gallery_header}
          </span>
          <Link
            data-testid="gallery-back-link"
            to="/"
            className="flex items-center gap-2 rounded-full border border-[#F4F1EB]/30 px-4 py-2 text-xs uppercase tracking-[0.2em] transition-colors duration-300 hover:bg-[#F4F1EB] hover:text-[#102C1F]"
          >
            <ArrowLeft size={14} /> {site.gallery_back}
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-7xl px-5 py-14 md:px-10 md:py-20">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="mb-12 font-display text-4xl italic tracking-tight sm:text-5xl"
        >
          {site.gallery_title}
        </motion.h1>
        <div className="grid grid-cols-2 gap-5 md:grid-cols-3 lg:grid-cols-4">
          {photos.map((p, i) => (
            <motion.figure
              key={`${p.name}-${i}`}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{
                duration: 0.7,
                delay: (i % 4) * 0.08,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="group"
            >
              <div className="aspect-[4/5] w-full overflow-hidden rounded-sm bg-[#102C1F]/5">
                <img
                  src={p.img}
                  alt={p.name}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
              </div>
              <figcaption className="mt-2 h-4 truncate text-xs uppercase tracking-[0.2em] text-[#102C1F]/60">
                {p.name || ""}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </main>
    </div>
  );
}
